import { action, observable, makeObservable } from 'mobx';

export class CallInvitation {
  @observable selfName: string | null = null;
  @observable channelId: string | null;

  constructor() {
    makeObservable(this);
  }

  @action setChannelId(id: string | null): void {
    this.channelId = id;
  }

  @action setSelfName(name: string): void {
    this.selfName = name;
  }

  @action reset(): void {
    this.channelId = null;
  }
}
